<template>
	<div class="form">
		<div class="bag" v-if="bag==1" @click="bagClick()"></div>
		<div class="form-div" v-if="bag==1">
			<div class="title">比赛报名</div>
			<div class="input-div" v-for="(item,index) in form.form" :key="index">
				<label class="label" :class="item.obj.require==true ? 'label1':''">{{item.obj.label}}:</label>
				<div  v-if="item.ele=='input'">
					<el-input  type="text" v-model="item.obj.relation_value"></el-input> 
				</div>
				
				
				<div v-if="item.ele=='radio'">
					<el-radio v-for="(it,one) in item.obj.items" :key="one" v-model="item.obj.relation_value" :label="it.label_value">
						{{it.label_name}}
					</el-radio>
				</div>
				<div v-if="item.ele=='checkbox'">
					<el-checkbox-group v-model="item.obj.relation_value">
					    <el-checkbox v-for="(it,one) in item.obj.items" :key="one"  @change="checkListChange(it.label_value,index)"  :label="it.label_value">{{it.label_name}}</el-checkbox>
					</el-checkbox-group>
				</div>
				
				<div v-if="item.ele=='datepicker'">
					<el-date-picker
				      v-model="item.obj.relation_value"
				      type="date"
				      placeholder="选择日期">
				    </el-date-picker>
				</div>
				
				<div  v-if="item.ele=='text'">
					<el-input  type="textarea" v-model="item.obj.relation_value"></el-input> 
				</div>
			
			</div>
			
			<div class="input-div" style="margin-top: 2rem;">
				 <el-button size="small" type="primary" @click="ti()">提交</el-button>
			</div>
			
			<!-- <div class="input-div">
				<label class="label" >复选框:</label>
				<div>
					<el-checkbox-group v-model="checkList">
					    <el-checkbox label="复选框 A"></el-checkbox>
					    <el-checkbox label="复选框 B"></el-checkbox>
						<el-checkbox label="复选框 C"></el-checkbox>
					</el-checkbox-group>
				</div>
				
			</div> -->
			<!-- 
			<div class="input-div">
				<label class="label" >单选框:</label>
				
				
			</div>
			
			<div class="input-div">
				<label class="label" >时间:</label>
				<div>
					<el-date-picker
				      v-model="value1"
				      type="date"
				      placeholder="选择日期">
				    </el-date-picker>
				</div>
			</div>
			
			
			<div class="input-div">
				<label class="label" >多行文本:</label>
				<div>
					<el-input
					  type="textarea"
					  placeholder="请输入内容"
					  v-model="textarea"
					  maxlength="30"
					  autosize
					></el-input>
				</div>
			</div> -->
			
			
			
			
		</div>
	</div>
</template>

<script>
	export default {
		props: ['form','bag'],
	    data() {
	      return {
			form : [],
			// bag  : ''
	      }
	    },
		 watch: {
			obj: {
			  handler (n, o) {
				console.log('子组件中的name值： ' + n.name)
			  },
			  deep: true // 深度监听父组件传过来对象变化
			}
		  },
		
		methods:{
			ti(){
				let that   = this;
				for(var i=0;i<that.form.form.length;i++){
					if(that.form.form[i]['obj']['require']==true && that.form.form[i]['obj']['relation_value'] == ''){
						that.$message({message: that.form.form[i]['obj']['ruleError'], type: 'error' });	return;
					}
				}
			
			
				
				that.$http('post','/api/v1/game/form_apply',{'form_id':that.form.id,'game_id':that.form.game_id,'form':JSON.stringify(that.form.form)}) .then(function (res) {
					var type = '';
					if(res.code==200){
						type ='success';
					}else{
						type ='error';
					}
					that.$message({message: res.msg, type: type });
					that.$emit('childFn', 0)
				});
				
			},
			bagClick(){
				this.$emit('childFn', 0)
			},
			checkListChange(e,index){
				let that = this;
				var form  = that.form.form;
				
				if(form[index]['obj']['relation_value'].length !=undefined){
					console.log(2);
					if(form[index]['obj']['relation_value'].includes(e)){
						form[index]['obj']['relation_value'].splice(form[index]['obj']['relation_value'].indexOf(e),1);
					}else{
						form[index]['obj']['relation_value'].push(e);
					}
				}else{
					form[index]['obj']['relation_value']  = [];
					form[index]['obj']['relation_value'].push(e);
				}
				
				that.form.form =form; 
				console.log(that.form.form);
				
			}
		}
	  
	}
</script>

<style lang="less">
		@import  '../../../common/css/form.less';
	.label1:before {
		    content: "*";
		    display: inline-block;
		    margin-right: 4px;
		    line-height: 1;
		    font-family: SimSun;
		    font-size: 12px;
		    color: #ed3f14;
			padding-top: 0.6rem;
	}	
</style>
